const defaultApplicant = () => ({
  remark: "",
  nrc_front: "",
  nrc_back: "",
  census_front: "",
  census_back: "",
  employee_card: "",
  selfie_photo: "",
  bill_photo: "",
  salary_slip: "",
  ward_recommendation_letter: "",
  company_hr_recommendation_letter: "",
  type: "applicant-document",
  completed_percent: 0,
});

const defaultGuarantor = () => ({
  nrc_front: "",
  nrc_back: "",
  census_front: "",
  census_back: "",
  employee_card: "",
  selfie_photo: "",
  bill_photo: "",
  type: "guarantor-superior-document",
  completed_percent: 0,
});

const state = () => ({
  upload_document: {
    loan_id: "",
    stage: "",
    product_name: "",
    brand_name: "",
    loan_amount: "",
    tenor: "",
    applicant: defaultApplicant(),
    guarantor_superior: defaultGuarantor(),
  },
});

const getters = {};
const actions = {};

const mutations = {
  updateLoanID(state, loan_id) {
    state.upload_document.loan_id = loan_id;
  },

  resetDocuments(state) {
    state.upload_document.applicant = defaultApplicant();
    state.upload_document.guarantor_superior = defaultGuarantor();
  },

  documentDetails(state, responseData) {
    const upload = state.upload_document;

    upload.applicant = defaultApplicant();
    upload.guarantor_superior = defaultGuarantor();

    upload.stage = responseData?.stage || upload.stage;
    upload.loan_amount = responseData?.plan?.unit_price || upload.loan_amount;
    upload.tenor = responseData?.plan?.tenure || upload.tenor;
    upload.brand_name = responseData?.plan?.brand_name || upload.brand_name;
    upload.product_name =
      responseData?.plan?.product_name || upload.product_name;

    if (responseData?.applicant) {
      const resApplicant = responseData.applicant;

      upload.applicant.remark = responseData?.remark || "";
      upload.applicant.nrc_front = resApplicant.nrc_front || "";
      upload.applicant.nrc_back = resApplicant.nrc_back || "";
      upload.applicant.census_front = resApplicant.census_front || "";
      upload.applicant.census_back = resApplicant.census_back || "";
      upload.applicant.employee_card = resApplicant.employee_card || "";
      upload.applicant.selfie_photo = resApplicant.selfie_photo || "";
      upload.applicant.bill_photo = resApplicant.bill_photo || "";
      upload.applicant.salary_slip = resApplicant.salary_slip || "";
      upload.applicant.ward_recommendation_letter =
        resApplicant.ward_recommendation_letter || "";
      upload.applicant.company_hr_recommendation_letter =
        resApplicant.company_hr_recommendation_letter || "";
      upload.applicant.completed_percent = resApplicant.completed_percent || 0;
    }

    if (responseData?.guarantor_superior) {
      const resGuarantor = responseData.guarantor_superior;

      upload.guarantor_superior.nrc_front = resGuarantor.nrc_front || "";
      upload.guarantor_superior.nrc_back = resGuarantor.nrc_back || "";
      upload.guarantor_superior.census_front = resGuarantor.census_front || "";
      upload.guarantor_superior.census_back = resGuarantor.census_back || "";
      upload.guarantor_superior.employee_card =
        resGuarantor.employee_card || "";
      upload.guarantor_superior.selfie_photo = resGuarantor.selfie_photo || "";
      upload.guarantor_superior.bill_photo = resGuarantor.bill_photo || "";
      upload.guarantor_superior.completed_percent =
        resGuarantor.completed_percent || 0;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
